import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-settle_data_manage",
  "use": "icon-settle_data_manage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-settle_data_manage\"><path fill=\"currentColor\" d=\"M896 72.128V960H128V72.128h768z m-419.008 629.76H256v63.616h220.992v-63.616z m291.008 0H547.008v63.616H768v-63.616zM476.992 571.392H256v63.616h220.992v-63.616z m291.008 0H547.008v63.616H768v-63.616zM768 192H256v192h512V192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol